import React from 'react';
import { Document, Text, View, Page, Image } from '@react-pdf/renderer';

import capaPdf from '../../assets/capa-pdf.png';
import capaPdfEn from '../../assets/capa-pdf-en.png';
import stylePdf from './stylePdf';

interface IPdfData {
  payload: {
    machine: {
      date: string;
      language: string;
    };
  };
}

const ExportPdfPartsByMachine: React.FC<IPdfData> = ({ payload }) => {
  let coverSheet = capaPdf;
  if (payload.machine.language !== 'ptbr') {
    coverSheet = capaPdfEn;
  }
  return (
    <Document>
      <Page
        size="A4"
        style={{ justifyContent: 'center', alignItems: 'center' }}
        wrap
      >
        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Image
            source={coverSheet}
            style={{ width: '102%', height: '101%' }}
          />
          <Text style={stylePdf.year}>{payload.machine.date}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ExportPdfPartsByMachine;
